import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { ASSETS, HERO } from "@/data/content";
import { t } from "@/data/texts";
import { img } from "@/data/images";
import { FliesSlogan, ChristmasLights, AgeStamp } from "@/components/effects/Effects";

export default function Hero() {
  return (
    <header
      id="top"
      className="scanlines relative min-h-[100svh] flex items-center overflow-hidden border-b border-white/10"
      data-testid="hero"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={img("hero1", ASSETS.hero1)}
          alt="Opuštěný dům HUBERT"
          className="w-full h-full object-cover opacity-70"
          style={{ filter: "grayscale(0.15) contrast(1.02) brightness(1.05)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-[#030303]" />
      </div>

      <ChristmasLights count={16} />

      <div className="relative z-30 max-w-7xl mx-auto px-5 w-full pt-28 pb-16">
        <div className="flex items-center gap-3 mb-6">
          <span className="rec-dot" />
          <span className="text-xs tracking-[0.35em] text-red-600 font-bold">REC — LIVE FEED</span>
          <AgeStamp className="ml-2" />
        </div>

        <motion.img
          src={img("logoPsychoactive", ASSETS.logoPsychoactive)}
          alt="Psychoactive Escapecore"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: [0, 1, 0.85, 1], scale: 1 }}
          transition={{ duration: 2, times: [0, 0.4, 0.7, 1] }}
          className="mx-auto w-full max-w-3xl h-auto mb-10 glow-nv"
          style={{ filter: "drop-shadow(0 0 30px rgba(0,0,0,0.8))" }}
        />

        <p className="text-xs sm:text-sm tracking-[0.4em] text-nv mb-4 uppercase">{t("hero.kicker", HERO.kicker)}</p>

        <h1 className="font-head text-4xl sm:text-6xl lg:text-7xl uppercase tracking-tight text-neutral-100 max-w-4xl leading-[0.95]"
          style={{ textShadow: "0 2px 20px rgba(0,0,0,0.9)" }}>
          <FliesSlogan text={t("hero.slogan", HERO.slogan)} className="vhs-glitch" />
        </h1>

        <p className="mt-8 text-base sm:text-lg text-neutral-300 max-w-2xl leading-relaxed"
          style={{ textShadow: "0 1px 10px rgba(0,0,0,0.9)" }}>{t("hero.sub", HERO.sub)}</p>

        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href="#rezervace"
            data-testid="hero-cta"
            className="hud-btn vhs-btn font-head tracking-[0.2em] px-8 py-4 text-sm sm:text-base"
          >
            [ {t("hero.cta", HERO.cta)} ]
          </a>
        </div>
      </div>

      <a
        href="#o-hre"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 text-neutral-500 hover:text-nv animate-bounce"
        aria-label="Scroll dolů"
      >
        <ChevronDown className="w-7 h-7" />
      </a>
    </header>
  );
}
